import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { memo, } from 'react';
import { Typography, Grid, Accordion, AccordionSummary, AccordionDetails, } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import 'katex/dist/katex.min.css';
import { Field } from 'formik';
// Internal dependencies
import { SelectSG } from '../components';
import { CustomInputAction } from './CustomInputAction';
import { CustomToolAction } from './CustomToolAction';
import { CustomPromptAction } from './CustomPromptAction';
import { ACTION_TYPES } from './constants';
import { workflowStyles } from './workflowStyles';
import { WorkflowActionHeader } from './WorkflowActionHeader';
const actionOptions = [
    { title: 'Input', value: ACTION_TYPES.INPUT },
    { title: 'Tool', value: ACTION_TYPES.TOOL },
    { title: 'Prompt', value: ACTION_TYPES.PROMPT },
];
/**
 * Custom Workflow Action component
 * @param props Props
 * @returns Custom Workflow Action
 */
export const CustomWorkflowAction = memo(function ({ action, actionErrors, actionTouched, actionIdx, setFieldValue, }) {
    // Get translation function
    const { t, i18n } = useTranslation();
    /**
     * Get Custom Action body
     * @returns Action body element
     */
    const getActionBody = () => {
        const actionType = action === null || action === void 0 ? void 0 : action.type;
        switch (actionType) {
            case ACTION_TYPES.INPUT:
                return (_jsx(CustomInputAction, { action: action, actionIdx: actionIdx, actionErrors: actionErrors, actionTouched: actionTouched }));
                break;
            case ACTION_TYPES.TOOL:
                return (_jsx(CustomToolAction, { action: action, actionIdx: actionIdx, actionErrors: actionErrors, actionTouched: actionTouched, setFieldValue: setFieldValue }));
                break;
            case ACTION_TYPES.PROMPT:
                return (_jsx(CustomPromptAction, { action: action, actionIdx: actionIdx, actionErrors: actionErrors, actionTouched: actionTouched, setFieldValue: setFieldValue }));
                break;
            default:
                return (_jsx(CustomPromptAction, { action: action, actionIdx: actionIdx, actionErrors: actionErrors, actionTouched: actionTouched, setFieldValue: setFieldValue }));
        }
    };
    /**
     * Is this action got any error
     * @returns True/false
     */
    const isError = () => {
        const /** Workflow Action type */ actionType = action === null || action === void 0 ? void 0 : action.type;
        switch (actionType) {
            case ACTION_TYPES.INPUT:
                const inputErrors = (actionErrors === null || actionErrors === void 0 ? void 0 : actionErrors.inputs) && actionErrors.inputs.map((input) => (Boolean(input === null || input === void 0 ? void 0 : input.name) || Boolean(input === null || input === void 0 ? void 0 : input.description)));
                return (inputErrors || []).findIndex((inputError) => (inputError === true)) > -1;
                break;
            case ACTION_TYPES.TOOL:
                const toolError = actionErrors === null || actionErrors === void 0 ? void 0 : actionErrors.promptContent;
                return toolError;
                break;
            case ACTION_TYPES.PROMPT:
                const promptError = actionErrors === null || actionErrors === void 0 ? void 0 : actionErrors.promptContent;
                return promptError;
                break;
        }
        return false;
    };
    return (_jsxs(Accordion
    //elevation={0}
    , Object.assign({ 
        //elevation={0}
        expanded: isError() ? true : undefined, sx: {
            padding: '1rem',
            cursor: 'default',
            borderRadius: '12px!important',
            boxSizing: 'border-box',
            border: '1px solid',
            borderColor: isError() ? '#ff0000' : 'greyLight.main',
            boxShadow: 'none',
            width: '100%',
            backgroundColor: 'whiteDark.main',
            '& .MuiAccordionSummary-content': {
                margin: '0!important',
            },
            '& h1.MuiTypography-root': {
                padding: '0!important',
            },
            '& .MuiButtonBase-root.MuiAccordionSummary-root': {
                minHeight: '0',
            },
        }, id: "custom-workflow-action-accordion" }, { children: [_jsx(AccordionSummary, Object.assign({ expandIcon: _jsx(ExpandMore, { sx: { color: 'black.main' } }), "aria-controls": "panel1a-content", id: "panel1a-header", sx: {
                    width: '100%',
                    '&': {
                        cursor: 'default',
                        zIndex: '2',
                        backgroundColor: 'transparent',
                        margin: '0',
                        padding: '0',
                    },
                    '& .MuiAccordionSummary-content': {
                        overflow: 'hidden',
                    },
                } }, { children: _jsx(WorkflowActionHeader, { action: action }) })), _jsxs(AccordionDetails, Object.assign({ sx: {
                    padding: '1.5rem 0 0',
                    backgroundColor: 'transparent',
                    height: '100%',
                    boxSizing: 'border-box',
                    width: '100%',
                } }, { children: [_jsxs(Grid, Object.assign({ container: true, sx: { alignItems: 'center', width: '100%' } }, { children: [_jsx(Typography, Object.assign({ sx: Object.assign({ width: '100%' }, workflowStyles.actionHeading1) }, { children: t('Type').toUpperCase() })), _jsx(Field, { as: SelectSG, items: actionOptions, name: `actions[${actionIdx}].type`, xstyles: { '& p': Object.assign({}, workflowStyles.actionInput), } })] })), getActionBody()] }))] })));
});
